import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexRowDiv } from "../common.styles";
export { SearchRow, SearchSection, SectionHeader } from "./GlobalAdminDocumentRetrieval.styles";
export { PatientDetailsCard } from "./GlobalAdminDocumentRetrieval.styles";
export { EmptyState, ErrorMessage, LoadingOverlay } from "./GlobalAdminShared.styles";
export const FeatureEnablementViewParent = styled.div ``;
export const ScopeCaveatNote = styled.div `
    max-width: 900px;
    margin-bottom: 24px;
    font-size: ${fontSizes.STANDARD};
    line-height: 20px;
    color: ${colors.black_lighter};
`;
export const ScopeSearchBlock = styled.div `
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
export const ScopeSearchRow = styled(FlexRowDiv) `
    gap: 12px;
    align-items: flex-start;
`;
export const ScopeFieldGroup = styled(FlexRowDiv) `
    gap: 12px;
    flex: 1;
`;
export const ScopeField = styled.div `
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-width: 200px;
`;
export const ScopeFieldMessageSlot = styled.div `
    min-height: 16px;
    font-size: 12px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const ScopeFieldHelperError = styled.div `
    color: ${colors.tulip_main};
`;
export const ScopeFieldHelperResolved = styled.div `
    color: ${colors.black_lighter};
`;
export const ScopeFieldLabel = styled.label `
    font-size: 13px;
    line-height: 16px;
    color: ${colors.black_lighter};
`;
export const ScopeLookupButtonWrap = styled.div `
    flex-shrink: 0;
    margin-top: 22px;
`;
export const ScopeSearchHelperRow = styled(FlexRowDiv) `
    gap: 12px;
`;
export const ScopeFieldHelper = styled.div `
    flex: 1;
    min-width: 200px;
    min-height: 16px;
    font-size: 12px;
    line-height: 16px;
    color: ${colors.tulip_main};
`;
export const ScopeLookupHelperSpacer = styled.div `
    flex-shrink: 0;
    width: 88px;
`;
export const ResolvedScopeBanner = styled.div `
    margin-bottom: 24px;
    padding: 12px 16px;
    background-color: ${colors.blue_5};
    border: 1px solid ${colors.blue_main};
    border-radius: 8px;
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_main};
`;
export const MasterDetailLayout = styled(FlexRowDiv) `
    gap: 24px;
    align-items: stretch;
    min-height: 400px;
`;
export const MasterPanel = styled.div `
    flex: 0 0 420px;
    background-color: white;
    border: 1px solid ${colors.black_30};
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    min-height: 480px;
`;
export const DetailPanel = styled.div `
    flex: 1;
    background-color: white;
    border: 1px solid ${colors.black_30};
    border-radius: 8px;
    padding: 20px;
    min-height: 480px;
`;
export const FeatureListHeader = styled(FlexRowDiv) `
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    gap: 8px;
`;
export const FeatureListTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: 600;
    flex-shrink: 0;
`;
export const FeatureListToolbar = styled(FlexRowDiv) `
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`;
export const FeatureListSortToggleGroup = styled(FlexRowDiv) `
    align-items: center;
    gap: 4px;
`;
export const FeatureListSortToggleButton = styled.button `
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => (props.$text ? "auto" : "28px")};
    min-width: 28px;
    height: 28px;
    padding: ${(props) => (props.$text ? "0 7px" : "0")};
    border: none;
    border-radius: 999px;
    background-color: ${(props) => (props.$selected ? colors.navy_main : "transparent")};
    color: ${(props) => (props.$selected ? colors.white_main : colors.black_lighter)};
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:not(:disabled):hover {
        background-color: ${(props) => (props.$selected ? colors.navy_main : colors.black_4)};
    }

    svg {
        font-size: 18px;
    }
`;
export const FeatureListSortToggleLabel = styled.span `
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: -0.02em;
`;
export const FeatureListSearchRow = styled.div `
    margin-bottom: 12px;
`;
export const FeatureListSearchFieldWrap = styled.div `
    position: relative;
    width: 100%;
`;
export const FeatureListSearchInput = styled.input `
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    border: 1px solid ${colors.black_30};
    border-radius: 6px;
    font-size: ${fontSizes.STANDARD};

    &:focus {
        outline: none;
        border-color: ${colors.blue_main};
    }

    &:disabled {
        background-color: ${colors.black_4};
        color: ${colors.black_lighter};
    }

    &::-webkit-search-cancel-button {
        cursor: pointer;
    }
`;
export const ScopeSearchAutocompleteWrap = styled.div `
    width: 100%;

    .MuiAutocomplete-clearIndicator {
        visibility: visible;
        padding: 2px;
    }

    .MuiAutocomplete-clearIndicator .MuiSvgIcon-root {
        width: 14px;
        height: 14px;
        color: ${colors.black_lighter};
    }

    .MuiAutocomplete-popupIndicator {
        padding: 2px;
    }

    .MuiAutocomplete-popupIndicator .MuiSvgIcon-root {
        color: ${colors.black_lighter};
    }
`;
export const FeatureListRolloutFilter = styled.label `
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: ${colors.black_lighter};
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
`;
export const FeatureListRolloutFilterCheckbox = styled.input `
    margin: 0;
`;
export const FEATURE_SCOPE_MATRIX_WIDTH = "120px";
export const FeatureScopeMatrixGrid = styled.div `
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: ${FEATURE_SCOPE_MATRIX_WIDTH};
    align-items: center;
`;
export const FeatureListColumnHeaders = styled.div `
    display: grid;
    grid-template-columns: minmax(0, 1fr) ${FEATURE_SCOPE_MATRIX_WIDTH};
    gap: 8px;
    padding: 0 12px 8px;
    border-bottom: 1px solid ${colors.black_12};
    margin-bottom: 4px;
    align-items: end;
`;
export const FeatureListColumnHeaderLabel = styled.div `
    font-size: 12px;
    font-weight: 600;
    color: ${colors.black_lighter};
    text-transform: uppercase;
    text-align: ${(props) => { var _a; return (_a = props.$align) !== null && _a !== void 0 ? _a : "left"; }};
`;
export const FeatureList = styled.div `
    flex: 1;
    overflow-y: auto;
    margin: 0 -8px;
`;
export const FeatureListRow = styled.button `
    display: grid;
    grid-template-columns: minmax(0, 1fr) ${FEATURE_SCOPE_MATRIX_WIDTH};
    gap: 8px;
    width: 100%;
    padding: 10px 12px;
    border: none;
    border-radius: 6px;
    background-color: ${(props) => (props.$selected ? colors.blue_5 : "transparent")};
    cursor: pointer;
    text-align: left;
    align-items: center;

    &:hover {
        background-color: ${(props) => (props.$selected ? colors.blue_5 : colors.black_4)};
    }
`;
export const FeatureListRowName = styled.div `
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_main};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const FeatureScopeColumnHeader = styled.div `
    text-align: center;
    font-size: 11px;
    font-weight: 600;
    color: ${colors.black_lighter};
    text-transform: uppercase;
`;
export const FeatureScopeCell = styled.div `
    height: 28px;
    width: 28px;
    justify-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    box-shadow: ${(props) => (props.$isResolved ? `0 0 0 2px ${colors.navy_main}` : "none")};
`;
export const FeatureScopeCellDot = styled.div `
    width: ${(props) => (props.$state === "unset" ? "4px" : "10px")};
    height: ${(props) => (props.$state === "unset" ? "4px" : "10px")};
    border-radius: 999px;
    background-color: ${(props) => {
    if (props.$state === "enabled") {
        return colors.forest_main;
    }
    if (props.$state === "disabled") {
        return colors.sunset_main;
    }
    return colors.black_30;
}};
`;
export const FeatureScopeNotEnabledLabel = styled.div `
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    padding: 2px 8px;
    background-color: ${colors.black_4};
    border: 1px solid ${colors.black_12};
    border-radius: 6px;
    font-size: 12px;
    color: ${colors.black_lighter};
    text-align: center;
`;
export const FeatureDetailTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: 600;
    margin-bottom: 4px;
`;
export const FeatureDetailSubtitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_lighter};
    margin-bottom: 20px;
`;
export const FeatureDetailSummaryRow = styled(FlexRowDiv) `
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${colors.black_12};
`;
export const FeatureDetailResolvedSummary = styled.div `
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_lighter};
`;
export const FeatureEnablementScopeCardShell = styled.div `
    background-color: white;
    border: ${(props) => (props.$isResolvedScope ? `2px solid ${colors.navy_main}` : `1px solid ${colors.black_30}`)};
    border-radius: 8px;
    padding: 20px;
`;
export const ScopeCardsStack = styled.div `
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
export const ScopeCardTitleWrap = styled.div `
    flex: 1;
    min-width: 0;
`;
export const ScopeCardTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const ScopeCardHeader = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
`;
export const ScopeCardBody = styled.div `
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
export const ScopeCardActions = styled.div `
    display: flex;
    gap: 12px;
    margin-top: 4px;
`;
export const ScopeCardSaveButton = styled.div `
    min-width: 120px;
`;
export const ScopeCardValidationError = styled.div `
    font-size: 13px;
    color: ${colors.tulip_main};
`;
export const FeatureConfigTextArea = styled.textarea `
    width: 100%;
    min-height: 120px;
    padding: 12px;
    border: 1px solid ${colors.black_30};
    border-radius: 6px;
    font-family: monospace;
    font-size: 12px;
    resize: vertical;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: ${colors.blue_main};
    }

    &:disabled {
        background-color: ${colors.black_4};
        color: ${colors.black_lighter};
    }
`;
export const ScopeCardUnsetMessage = styled.div `
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_lighter};
`;
export const ScopeCardField = styled.div `
    margin-bottom: 10px;
    font-size: ${fontSizes.STANDARD};
`;
export const ScopeCardFieldLabel = styled.span `
    font-weight: 600;
    color: ${colors.black_main};
`;
export const ScopeCardConfigPreview = styled.pre `
    margin: 8px 0 0;
    padding: 12px;
    background-color: ${colors.black_4};
    border: 1px solid ${colors.black_12};
    border-radius: 6px;
    font-size: 12px;
    overflow-x: auto;
    white-space: pre-wrap;
    word-break: break-word;
`;
export const ScopeCardTimestamp = styled.div `
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 12px;
    font-size: 13px;
    color: ${colors.black_lighter};
`;
export const ScopeCardTimestampLine = styled.div ``;
